/* eslint-disable */
import React from 'react'
import Page from '../../Component/Pagination/Pagination'
import http from '../../Component/Interceptor/Interseptor'
import HeaderTable from '../BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import {message} from 'antd'
import jMoment from 'moment-jalaali'
import {accounting} from 'accounting'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import $ from 'jquery'
import cookie from 'react-cookies'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import FromToPicker from '../BaseComponent/FromToPicker'
import SearchableCombo from '../BaseComponent/searchableCombo'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import Loader from '../loaders/loader'

class DeliveryPackByTime extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,

      printInfo: [],
      delivery: [],
      buttonClicked: false,
      fromDate: '',
      toDate: '',
      grouping: 0,
      Drivers: [],
      driverId: ''
    }
  }

  getDelivery = (
    pageNumber = sessionStorage.getItem('pageNumber'),
    pageSize = sessionStorage.getItem('dropDownVal'),
    params = sessionStorage.getItem('params')
  ) => {
    this.setState({
      loading: true
    })
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DELIVERY_TIME
        }?export=false&pageNumber=${pageNumber}&pageSize=${pageSize}&${params}`,
        {}
      )
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()

          this.setState({
            delivery: response.data.object.result,
            buttonClicked: true,
            countAll: response.data.object.countAll,
            loading: false
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            loading: false
          })
        }
      })
  }
  componentDidMount() {
    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }

          this.setState({
            Drivers: response.data.object
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', '')
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
  }

  onResultFetched(data) {
    this.setState({
      delivery: data
    })
  }

  changeDropDown(data) {
    this.setState({
      delivery: data,
      countAll: this.state.countAll
    })
  }

  filter() {
    var minDate = this.state.fromDate
    var maxDate = this.state.toDate
    let driverId = this.state.driverId == null || this.state.driverId == '' ? '' : this.state.driverId.personId

    var grouping = document.getElementById('grouping').value
    if (minDate === '' && maxDate === '' && grouping === '' && driverId === '') {
      message.error('حداقل یک فیلتر وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      this.setState({
        toPrintDate: minDate == '' ? '-' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
        fromPrintDate: maxDate == '' ? '-' : jMoment(this.state.toDate).format('jYY/jMM/jDD'),
        groupingStatus: Number(this.state.grouping)
      })
      sessionStorage.setItem('pageNumber', '1')

      sessionStorage.setItem(
        'params',
        `driverId=${driverId}&grouping=${grouping}&planDateMin=${minDate}&planDateMax=${maxDate}&sortBy=driverId_asc,jalaliDeliveryTime_asc`
      )
      this.getDelivery()
    }
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  changeGrouping(e) {
    let value = e.target.value
    let name = e.target.name
    this.setState({
      [name]: value
    })
  }

  getPrintInfo = () => {
    this.setState({
      loading: true
    })

    http
      .get(
        `${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DELIVERY_TIME}?export=true&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        if (response.data.error === null) {
          // alert(JSON.stringify(response.data))
          this.setState({
            printInfo: response.data.object.result,
            loading: false
          })
          setTimeout(() => {
            window.print()
          }, 2000)
        } else {
          // message.error(response.data.description)
          this.setState({
            loading: false
          })
        }
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
  }

  exportExcel = () => {
    http
      .get(
        `${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DELIVERY_TIME}?export=true&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['firstDeliveryDate'] = jMoment(excelReport[i]['firstDeliveryDate']).format('jYY/jM/JD HH:mm')
            excelReport[i]['lastDeliveryDate'] = jMoment(excelReport[i]['lastDeliveryDate']).format('jYY/jM/JD HH:mm')
            if (excelReport[i]['minDeliveryInterval'] !== null) {
              excelReport[i]['minDeliveryInterval'] = this.msToHMS(excelReport[i]['minDeliveryInterval'])
            }
            if (excelReport[i]['avgDeliveryInterval'] !== null) {
              excelReport[i]['avgDeliveryInterval'] = this.msToHMS(excelReport[i]['avgDeliveryInterval'])
            }
            if (excelReport[i]['maxDeliveryInterval'] !== null) {
              excelReport[i]['maxDeliveryInterval'] = this.msToHMS(excelReport[i]['maxDeliveryInterval'])
            }
          }
          this._export.save(this.state.excelReport)
        }
      })
  }

  msToHMS = (milisecond) => {
    var decimalDobule = 1
    var seconds = milisecond / 1000
    var hours = parseInt(seconds / 3600) // 3,600 seconds in 1 hour
    seconds = seconds % 3600 // seconds remaining after extracting hours
    var minutes = parseInt(seconds / 60) // 60 seconds in 1 minute
    seconds = (seconds % 60).toFixed(decimalDobule).replace(/.000/g, '')
    return hours + ' ساعت و ' + minutes + ' دقیقه و ' + seconds + ' ثانیه '
  }

  getValueDriver = (driverId) => {
    this.setState({
      driverId
    })
  }

  render() {
    let {loading} = this.state
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let urlParams = sessionStorage.getItem('params')
    let pageNumber = sessionStorage.getItem('pageNumber')
    let reporterName = cookie.load('name')
    let printCol = [
      'ردیف',
      'راننده',
      'تاریخ',
      'تعداد تحویل شده',
      'اولین تحویل',
      'آخرین تحویل',
      'حداقل زمان بین تحویل',
      'حداکثر زمان بین تحویل',
      'میانگین زمان بین تحویل'
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName={' گزارش زمانی تحویل بر مبنای : ' + (this.state.groupingStatus === 0 ? 'روزانه.xls' : '.xlsکلی')}
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'driver'}
                field={'driver.name'}
                title={'راننده'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'jalaliDeliveryTime'}
                field={'jalaliDeliveryTime'}
                title={'تاریخ'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'deliveredCount'}
                field={'deliveredCount'}
                title={'تعداد تحویل شده'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'firstDeliveryDate'}
                field={'firstDeliveryDate'}
                title={'اولین تحویل '}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'lastDeliveryDate'}
                field={'lastDeliveryDate'}
                title={'آخرین تحویل '}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'minDeliveryInterval'}
                field={'minDeliveryInterval'}
                title={'حداقل زمان بین تحویل'}
                width="250px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'maxDeliveryInterval'}
                field={'maxDeliveryInterval'}
                title={'حداکثر زمان بین تحویل'}
                width="250px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'avgDeliveryInterval'}
                field={'avgDeliveryInterval'}
                title={'میانگین زمان بین تحویل'}
                width="250px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header={' گزارش زمانی تحویل بر مبنای : ' + (this.state.groupingStatus === 0 ? ' روزانه' : 'کلی')}
              reporter={reporterName}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              headerColSpan={10}
              rightColSpan={5}
              centerColSpan={1}
              leftColSpan={4}
              centerSection={''}
              rightSection={
                'تاریخ از : ' +
                (this.state.toPrintDate === undefined ? '' : this.state.toPrintDate) +
                ' تا ' +
                (this.state.fromPrintDate === undefined ? '' : this.state.fromPrintDate)
              }
              columns={printCol}
            />

            <tbody>
              {this.state.printInfo.map((list, index) => (
                <tr key={'i' + index} style={index % 2 == 0 ? {backgroundColor: '#f1f1f1'} : {backgroundColor: '#fff'}}>
                  <td>{index + 1}</td>
                  <td>{list.driver.name}</td>
                  <td>{list.jalaliDeliveryTime}</td>
                  <td>{list.deliveredCount}</td>
                  <td>{jMoment(list.firstDeliveryDate).format('jYY/jM/jD HH:mm')}</td>
                  <td>{jMoment(list.lastDeliveryDate).format('jYY/jM/jD HH:mm')}</td>
                  <td>{list.minDeliveryInterval === null ? '' : this.msToHMS(list.minDeliveryInterval)}</td>
                  <td>{list.maxDeliveryInterval === null ? '' : this.msToHMS(list.maxDeliveryInterval)}</td>
                  <td>{list.avgDeliveryInterval === null ? '' : this.msToHMS(list.avgDeliveryInterval)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>توزیع</li>
            <li>تحویل فاکتور ها</li>
            <li>گزارش زمانی</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  printUrl=""
                  url={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DELIVERY_TIME}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printComponent={this.printTable}
                  execelUrl={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DELIVERY_TIME + '?export=true'}
                  excelColumns={[]}
                  titleAdd=""
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ از"
                  toLabel="تاریخ تا"
                  defaulValue={true}
                  fromId="from"
                  toId="to"
                />

                <div className="formComponent">
                  <label>بر مبنای </label>
                  <select
                    className="form-control"
                    name="grouping"
                    onChange={this.changeGrouping.bind(this)}
                    id="grouping"
                  >
                    <option value={0}>روزانه</option>
                    <option value={1}>کلی</option>
                  </select>
                </div>
                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.Drivers}
                    getValueCombo={this.getValueDriver}
                    lableText="رساننده"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    isDisabled={false}
                  />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>راننده</td>
                    {!this.state.groupingStatus ? <td>تاریخ</td> : ''}
                    <td>تعداد تحویل شده</td>
                    <td>اولین تحویل</td>
                    <td>آخرین تحویل</td>
                    <td>حداقل زمان بین تحویل</td>
                    <td>حداکثر زمان بین تحویل</td>
                    <td>میانگین زمان بین تحویل</td>
                  </tr>
                  {this.state.delivery.map((list, index) => (
                    <tr
                      key={index}
                      style={
                        list.supplyOrderQuantity !== list.cardexQuantity ||
                        list.deliveryQuantity !== list.detailQuantity
                          ? {backgroundColor: '#fdcccc'}
                          : {}
                      }
                    >
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{list.driver.name}</td>
                      {!this.state.groupingStatus ? <td>{list.jalaliDeliveryTime}</td> : ''}
                      <td>{list.deliveredCount}</td>
                      <td>{jMoment(list.firstDeliveryDate).format('jYY/jM/jD HH:mm')}</td>
                      <td>{jMoment(list.lastDeliveryDate).format('jYY/jM/jD HH:mm')}</td>
                      <td>{list.minDeliveryInterval === null ? '' : this.msToHMS(list.minDeliveryInterval)}</td>
                      <td>{list.maxDeliveryInterval === null ? '' : this.msToHMS(list.maxDeliveryInterval)}</td>
                      <td>{list.avgDeliveryInterval === null ? '' : this.msToHMS(list.avgDeliveryInterval)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.countAll}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DELIVERY_TIME}
                  urlParams={urlParams}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default DeliveryPackByTime
